import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getAccountId = () => useAuthorizationStore().getAccountSlug

const getVerificationData = () => axios.get(`${getAccountId()}/verification`)
const createVerificationData = ({ formData, config }) => axios.post(`${getAccountId()}/verification`, formData, config)

const updateVerificationBilling = (formData) => axios.post(`${getAccountId()}/verification/billing`, formData)

const updateVerificationKYC = ({ formData, config }) => axios.post(`${getAccountId()}/verification/kyc`, formData, config)

const updateVerificationCard = ({ formData, config }) => axios.post(`${getAccountId()}/verification/payment`, formData, config)

const createVerification = () => axios.post(`${getAccountId()}/verification/verification-url`)
const getStripeUrl = (type) => axios.get(`${getAccountId()}/verification/customer-portal/${type}`)
const getVerificationStatus = () => axios.get(`${getAccountId()}/verification/status`)
const getVerificationCardStatus = () => axios.get(`${getAccountId()}/verification/card/status`)
const updateVerificationProgress = (formData) => axios.patch(`${getAccountId()}/verification-progress`, formData)

export {
    createVerification,
    getVerificationData,
    createVerificationData,
    getVerificationStatus,
    getVerificationCardStatus,
    updateVerificationProgress,
    updateVerificationBilling,
    updateVerificationKYC,
    updateVerificationCard,
    getStripeUrl,
}
